import path from 'path';
import './replaceAllPolyfill';
import logger from './logging';
import {getRelativePath, resolvePath} from './utils';

export interface IVirtualPathResolver {
    resolve(virtualPath: string): string

    resolveUrl(virtualPath: string): string
}

export interface IVirtualPathStorage extends IVirtualPathResolver {
    add(virtualPath: string, realPath: string): void
}

export default class VirtualPathStorage implements IVirtualPathStorage {
    private readonly virtualToRealPathMappings = new Map<string, string>();

    add(virtualPath: string, realPath: string) {
        virtualPath = resolvePath(virtualPath);
        realPath = resolvePath(realPath);

        const duplicatedPath = this.virtualToRealPathMappings.get(virtualPath)
        if (duplicatedPath) {
            logger.warn({realPath, duplicatedPath}, `Detected conflicting paths.`);
        }

        this.virtualToRealPathMappings.set(virtualPath, realPath);
    }

    resolve(virtualPath: string): string {
        virtualPath = resolvePath(virtualPath);
        return this.virtualToRealPathMappings.get(virtualPath) || virtualPath;
    }

    resolveUrl(virtualUrl: string): string {
        const virtualPath = convertUrlToPath(virtualUrl);
        const realPath = this.resolve(virtualPath);

        return convertPathToUrl(realPath);
    }
}

export function convertPathToUrl(location: string) {
    return getRelativePath(location).replaceAll(path.sep, '/');
}

export function convertUrlToPath(location: string) {
    return resolvePath(location.replaceAll('/', path.sep));
}
